'use strict';

export default class LocationCodeFormController {
  /*@ngInject*/
  constructor($http, $q, $uibModalInstance, facility) {
    this.$http = $http;
    this.$q = $q;
    this.$uibModalInstance = $uibModalInstance;

    this.facility = facility;

    this.isAdd = true;
    this.form = {};
    this.submitted = false;
    this.isSaving = false;
    this.errors;
  }

  getData(id) {
    let self = this;
    this.$http.get(`/api/types/companies/${id}`)
      .then(function(response) {
        self.result = response.data;
      }, function(err) {

      });
  }

  update(form, id, payload) {
    let self = this;
    this.$http.put(`/api/types/companies/${id}`, payload)
      .then(function(response) {
        self.$uibModalInstance.close();
      }, function(err) {
        self.isSaving = false;
        // Update validity of form fields that match the mongoose errors
        self.errors = {};
        angular.forEach(err.data.errors, (error, field) => {
          form[field].$setValidity('mongoose', false);
          self.errors[field] = error.message;
        });
      });
  }

  create(form, payload) {
    let self = this;
    this.$http.post('/api/types/companies', payload)
      .then(function(response) {
        self.$uibModalInstance.close();
      }, function(err) {
        self.isSaving = false;
        // Update validity of form fields that match the mongoose errors
        self.errors = {};
        angular.forEach(err.data.errors, (error, field) => {
          form[field].$setValidity('mongoose', false);
          self.errors[field] = error.message;
        });
      });
  }

  submitForm(form) {
    if(form.$valid) {
      let self = this;
      this.submitted = true;
      this.isSaving = true;
      let payload = this.form;
      if(this.facility && this.facility._id) {
        this.update(form, this.facility._id, payload);
      } else {
        self.create(form, payload);
      }
    }
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  $onInit() {
    if(this.facility && this.facility._id) {
      this.isAdd = false;
      this.getData(this.facility._id);
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/locationCode.form.controller.js